import { render, staticRenderFns } from "./Diamond.vue?vue&type=template&id=67caea10&scoped=true"
var script = {}
import style0 from "./Diamond.vue?vue&type=style&index=0&id=67caea10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67caea10",
  null
  
)

export default component.exports